export const energyBlue = '#3a74e0';
export const lifeGreen = '#49e1ca';
export const fluidPink = '#fd8d82';
export const purpleRay = '#a142ff';
export const husk = '#B2A747';
